<template>
  <v-layout>
    <span v-if="getCountdownStatus.count > 0 && !startedTimer">{{prepareTimer()}}</span>
    <span v-if="getShowModalMessageResult">{{processModalResult()}}</span>
        <v-flex xs11 >
          <v-progress-linear style="margin-top:8px"
            :background-opacity="0.3"
            :rounded="true"
            :height="25"
            :value="cnt_value"
            color="light-blue"
          >{{Math.floor(getCountdownStatus.count/60)}}:{{getCountdownStatus.count % 60}}
          </v-progress-linear>
        </v-flex>
        <v-flex>
          <v-btn small @click="tryTofinishIt()">Submit ALL</v-btn>          
        </v-flex>
  </v-layout>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from '../../axios-auth.js'

export default {
  data() {
    return {
      startedTimer: false,
      timer : null,
      cnt_value:100
    }
  },
  beforeDestroy() {
    if (this.timer != null) {
      clearInterval(this.timer); 
      this.timer = null;
      this.startedTimer = false
    }
  },
  computed: 
    mapGetters([
                'getCountdownStatus',
                'getShowModalMessageResult'
            ])
  ,
  methods: {
    prepareTimer() { 
      if (this.startedTimer) return
      this.startedTimer = true
      this.cnt_value = Math.floor(this.getCountdownStatus.count/this.getCountdownStatus.max * 100)
      this.timer = setInterval(() => { if(this.getCountdownStatus.count <= 0) {
          
          clearInterval(this.timer); 
          this.timer = null;
          this.startedTimer = false
      } else {
          this.$store.commit('setCountdownDown')
          /* eslint-disable no-console */
          if (this.getCountdownStatus.count == 10) {            
            this.$store.commit('setSaveCode',true)
          }
          if (this.getCountdownStatus.count % 30 == 0) {            
            axios.post('/get-synchro/' + this.getCountdownStatus.id,{s_type : this.getCountdownStatus.synchro_type}, this.$store.getters.getAxiosConfig)
                .then((res) => {                    
                      this.$store.commit('setSaveCode',true)
                      this.$store.commit('setCountdownStatus', 
                          {id: this.getCountdownStatus.id, count: res.data.rem_time, 
                            max: this.getCountdownStatus.max, synchro_type: this.getCountdownStatus.synchro_type})
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })           
          }
          this.cnt_value = this.getCountdownStatus.count/this.getCountdownStatus.max * 100
          }
      }, 1000);
    },
    tryTofinishIt() {
        this.$store.commit('setShowModalMessage',
                            {content: 'Are you sure? Do you want to finish?', type: 'warning', 
                            buttons:[], icons:[{text:'close', color:'red', value: 1},{text:'done', color:'green', value: 2} ]})
    },
    finishIt() {
      this.$store.commit('setShowModalMessageResult',null)
      this.$store.commit('setCountdownStatus', 
                          {id: this.getCountdownStatus.id, count: 0, 
                            max: this.getCountdownStatus.max, synchro_type: this.getCountdownStatus.synchro_type})
    },
    processModalResult() {
      const res = this.getShowModalMessageResult
      this.$store.commit('setShowModalMessageResult',null)
      if (res == 2) {
          this.finishIt()
      }
    }
  }
  
}
</script>

<style>

</style>